import { UserResponse } from '../../types/dtos';
import { DeviceUserExemptionViewModel } from './deviceUserExemptionMappers';

export interface UserDeviceBypassFields {
  bypass: boolean;
  until: string | null;
}

/** Lê flags de bypass expostas no GET /users (GettelApi #552). */
export function readUserDeviceBypassFields(user: UserResponse): UserDeviceBypassFields {
  return {
    bypass: user.authorizedDeviceBypass ?? false,
    until: user.authorizedDeviceBypassUntilUtc ?? null,
  };
}

export function isUserDeviceBypassActive(user: UserResponse, now: Date = new Date()): boolean {
  const { bypass, until } = readUserDeviceBypassFields(user);
  if (!bypass) return false;
  if (until == null || until === '') return true;
  const expiry = new Date(until);
  if (Number.isNaN(expiry.getTime())) return true;
  return expiry.getTime() > now.getTime();
}

export function mapUserToDeviceUserExemptionViewModel(
  user: UserResponse
): DeviceUserExemptionViewModel {
  const { until } = readUserDeviceBypassFields(user);
  const email = user.email ?? '';
  const displayName = user.nome?.trim() || email || user.id;
  const updated =
    user.updatedAt instanceof Date
      ? user.updatedAt.toISOString()
      : user.updatedAt
        ? String(user.updatedAt)
        : '';

  return {
    id: user.id,
    userId: user.id,
    displayName,
    email,
    expiresAtUtc: until,
    isPermanent: until == null || until === '',
    createdAt: updated,
  };
}
